import { Divider, Grid, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import {
    Control,
    FieldErrors,
    useForm,
    UseFormRegister,
    UseFormReset,
    UseFormSetValue,
} from "react-hook-form";
import { shallowEqual, useSelector } from "react-redux";
import WSTextField, { CurrencyType, TextType } from "../../../Components/TextBox/WSTextBox";
import WSHiddenField from "../../../Components/HiddenField/WSHiddenField";
import WSButton from "../../../Components/Button/WSButton";
import React from "react";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { useNavigate, useParams } from "react-router-dom";
import { callAPI, Method, updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import { HeaderList, IHeaderListActions } from "../../../Components/Header/HeaderList";
import ConfirmDialog from "../../../Components/Confirmation/ConfirmDialog";

interface ProductProps {

}

const Product: React.FC<any> = React.memo((props) => {
    const { showMessage } = useSnackbar();
    const { register, handleSubmit, control, setValue, watch, reset, getValues } = useForm();
    const navigate = useNavigate();
    const params = useParams();
    const [userRoles, setUserRoles] = useState<any>([]);
    const [userPermissions, setUserPermissions] = useState<any>([]);
    const [permissions, setPermissions] = useState<any>([]);

    const [loading, setLoading] = useState(false);
    const id = params?.id;

    useEffect(() => {
        return () => {
            reset();
        };
    }, []);
    useEffect(() => {
        updateMainHeader("Products");
        breadCrumbsStore.updateBreadCrumbs([
            { "Products": "/product/list" },
            { [id ? 'Edit Product' : "Create Product"]: `` },
        ]);
    });
    useEffect(() => {
        async function getProductById(id: any): Promise<void> {
            try {
                const response: any = await callAPI('products', Method.GET, {}, id);
                if (response && response.data) {
                    if (response.data.permissions) {
                        setUserPermissions(response.data.permissions)
                    }
                    for (const field in response.data) {

                        setValue(field, (response?.data as any)[field]);
                    }
                }
            } catch (error) {
                showMessage('Error fetching user:', 'error');
            }
        }
        if (id) {
            getProductById(id);
        }
    }, [id])

    const handleCancelClick = () => {
        navigate('/product/list')
    }
    const handleProductData = async (data: any) => {
        try {
            setLoading(true)
            const response: any = await saveData(data);
            if (response && response?.message) {
                showMessage(response.message, response.success === true ? 'success' : 'error')
                navigate('/product/list')
            } else if (response?.id) {

                showMessage('Product Created Successfully', 'success')
                navigate('/product/list')
            }
        } catch (e: any) {
            showMessage(e.error);

        }
        finally {
            setLoading(false)
        }

    }
    const handleProductDataSaveAndNew = async (data: any) => {
        try {
            setLoading(true)
            const response: any = await saveData(data);
            if (response && response?.message) {
                reset()
                showMessage(response.message, response.success === true ? 'success' : 'error')
            } else if (response?.id) {

                showMessage('Product Created Successfully', 'success')
            }
        } catch (e: any) {
            showMessage(e.error);

        }
        finally {
            setLoading(false)
        }

    }
    const actions: IHeaderListActions[] =
        [
            { type: 'button', text: 'Cancel', size: 'small', onClick: handleCancelClick, variant: 'outlined', color: 'primary' },
            { type: 'button', text: 'Save & New', size: 'small', loading: loading, buttonType: 'submit', variant: 'outlined', color: 'primary', onClick: handleSubmit(handleProductData) },
            { type: 'button', text: 'Save', size: 'small', loading: loading, buttonType: 'submit', variant: 'outlined', color: 'primary', onClick: handleSubmit(handleProductDataSaveAndNew) }
        ]


    const saveData = async (data: any) => {

        const request: any = {
            "name": data?.name || "",
            "unit": data?.unit || "",
            "unitPrice": data?.unitPrice || "",
            "code": data?.code || "",
            "tax": data?.tax || "",

        }
        if (data?.productId) {
            const updatedFields = {
                updatedFields: {
                    "Name": data?.name || "",
                    "Unit": data?.unit || "",
                    "UnitPrice": Number(data?.unitPrice) || "",
                    "Code": data?.code || "",
                    "Tax": Number(data?.tax) || "",
                }
            }
            const response: any = await callAPI(`products`, Method.PUT, updatedFields, data?.productId);
            return response
        } else {
            const response: any = await callAPI("products", Method.POST, request);
            return response
        }
    }

    return (
        <Grid >
            {
                <>

                    <HeaderList title={!id ? "Add User" : "Update User"} isBackButton={true} url="/products/list" type="card" actions={actions} isDivider headerSx={{ height: 50 }} />
                    <Paper elevation={3} style={{ paddingLeft: 20, paddingRight: 20, marginTop: 0, paddingBottom: 25, border: '1px solid #ccc', borderRadius: '8px' }}>

                        <Grid container spacing={2} mt={2}>

                            <Grid item xs={12}>
                                <Typography fontWeight={"bold"}>Product Information</Typography>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <WSTextField
                                    label={"Product Name"}
                                    {...register("name")}
                                    id="name"
                                    name="name"
                                    control={control}
                                    rules={{ required: true }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <WSTextField
                                    label={"Product Code"}
                                    {...register("code")}
                                    id="code"
                                    name="code"
                                    control={control}
                                    rules={{ required: true }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <WSTextField
                                    label={"Unit"}
                                    {...register("unit")}
                                    id="unit"
                                    name="unit"
                                    control={control}
                                    rules={{ required: true }}

                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <WSTextField
                                    label={"Unit Price"}
                                    {...register("unitPrice")}
                                    id="unitPrice"
                                    name="unitPrice"
                                    control={control}
                                    rules={{ required: true }}
                                    type={TextType.Currency}
                                    currency={CurrencyType.Rupee}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <WSTextField
                                    label={"Tax"}
                                    {...register("tax")}
                                    id="tax"
                                    name="tax"
                                    control={control}
                                    rules={{ required: false }}
                                    type={TextType.Currency}
                                    currency={CurrencyType.Rupee}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Divider />
                            </Grid>

                            {/* <Grid item container spacing={2} style={{ paddingTop: '1rem' }} justifyContent={'end'}>
                                <Grid item sx={{ marginRight: 0 }}>
                                    <WSButton className="ws-theme-crm" variant="outlined" id='productSubmit' label={"Save"} type="submit" size="medium" loading={loading} />
                                </Grid>
                                <Grid item sx={{ marginRight: 0 }}>
                                    <WSButton id='cancel' label={"Cancel"} onClick={onCancel} type="button" size="medium" variant="outlined" className="ws-theme-crm" />
                                </Grid>
                            </Grid> */}
                        </Grid>
                    </Paper>

                

                </>
            }
        </Grid>

    );
});
export default Product;
